import { useQuery } from "@tanstack/react-query";

import useGetAccessToken from "components/Login/useGetAccessToken";
import { MEMORIES_QUERY_KEY } from "utilities/memory";
import { getMemories } from "../methods/memoryMethods";

/**
 * Fetches the user's memories, plus `threadId`'s pinned memories when given.
 * One request fills both sections of the memory view.
 */
export default function useMemoriesQuery(threadId: string | undefined) {
  const getAccessToken = useGetAccessToken();

  return useQuery({
    queryKey: [...MEMORIES_QUERY_KEY, threadId ?? "user"],
    queryFn: () => getMemories(threadId, getAccessToken),
    retry: false,
  });
}
